import { Divider } from "components/Divider/Divider"
import { Tag } from "components/Tag/Tag"
import { Tooltip } from "components/Tooltip/Tooltip"
import { ComponentProps } from "react"
import { cn } from "styles/cn"

export function Footnote({
	editedBy,
	editedByTooltip,
	labels = [],
	className,
	...props
}: {
	editedBy: string
	editedByTooltip?: string
	labels?: string[]
} & ComponentProps<"div">) {
	return (
		<div
			{...props}
			className={cn("flex flex-wrap items-center justify-end gap-1", className)}
		>
			{labels.length > 0 && (
				<>
					{labels.map((label) => (
						<Tag variant="filled" key={label} className="m-0">
							{label}
						</Tag>
					))}
					<Divider vertical />
				</>
			)}

			<Tooltip.Dark title={editedByTooltip}>
				<p className="shrink-0 text-navy-60">{editedBy}</p>
			</Tooltip.Dark>
		</div>
	)
}
